<template>
    <select
        :value="value"
        class="kgr-select"
        @change="update()"
    >
        <option
            :value="null"
            class="kgr-select__option"
        >
            {{ $t('pleaseChooseAnOption') }}
        </option>
        <option
            value="lastName"
            class="kgr-select__option"
        >
            {{ $t('member.lastName') }}
        </option>
        <option
            value="firstName"
            class="kgr-select__option"
        >
            {{ $t('member.firstName') }}
        </option>
        <option
            value="age"
            class="kgr-select__option"
        >
            {{ $t('member.age') }}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
    },

    methods: {
        update() {
            const value = this.$el.value;
            const selection = '' === value ? null : value
            this.$emit('input', selection);
            this.$nextTick(() => {
                this.$emit('post-input', selection);
            });
        },
    }
}
</script>
